<template>
  <div class="container">
    <h1 class="title">Editar Empresa</h1>
    <h1 class="subtitle">
      <span class="title is-5">{{ empresa.nombrec }}</span>
      <small class="title is-6"
        >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
      >
      <small class="subtitle is-7">{{ empresa.nombre }}</small>
    </h1>
    <hr />
    <div class="columns is-multiline">
      <div class="column is-4">
        <div class="field">
          <label class="label">Sigla</label>
          <div class="control">
            <input
              v-model="empresatoedit.nombrec"
              class="input"
              type="text"
              placeholder="Sigla"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
              v-model="empresatoedit.nombre"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Direccion</label>
          <div class="control">
            <input
              v-model="empresatoedit.direccion"
              class="input"
              type="text"
              placeholder="Direccion"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Teléfono</label>
          <div class="control">
            <input
              v-model="empresatoedit.telefono"
              class="input"
              type="text"
              placeholder="Teléfono"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Correo</label>
          <div class="control">
            <input
              v-model="empresatoedit.correo"
              class="input"
              type="email"
              placeholder="email"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Ciudad</label>
          <div class="select is-fullwidth">
            <select v-model="empresatoedit.codciudad">
              <option
                v-for="(op, ind) in ciudades"
                :value="op.codigo"
                :key="ind"
              >
                {{ op.codigo }} {{ op.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Pais</label>
          <div class="select is-fullwidth">
            <select v-model="empresatoedit.codpais">
              <option
                v-for="(op, ind) in paises"
                :value="op.codigo"
                :key="ind + 'p'"
              >
                {{ op.codigo }} {{ op.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Código Postal</label>
          <div class="control">
            <input
              v-model="empresatoedit.codpostal"
              class="input"
              type="text"
              placeholder="Código Postal"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Matrícula Mercantil</label>
          <div class="control">
            <input
              v-model="empresatoedit.mmercantil"
              class="input"
              type="text"
              placeholder="Matrícula Mercantil"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Tipo de Persona</label>
          <div class="select is-fullwidth">
            <select v-model="empresatoedit.tipopersona">
              <option value="1">Persona Jurídica</option>
              <option value="2">Persona Natural</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Tipo de Identificación</label>
          <div class="select is-fullwidth">
            <select v-model="empresatoedit.tidentif">
              <option value="31">Nit</option>
              <option value="13">Cédula de ciudadanía</option>
              <option value="11">Registro Civil</option>
              <option value="22">Cédula Extranjería</option>
              <option value="41">Pasaporte</option>
              <option value="12">Tarjeta de Identidad</option>
              <option value="21">Tarjeta Extranjería</option>
              <option value="42">Documento Identificación Extranjero</option>
              <option value="50">Nit de Otro País</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Responsabilidades Fiscales</label>
          <div class="select is-fullwidth is-multiple">
            <select multiple size="2" v-model="empresatoedit.regimen">
              <option value="O-13">Gran contribuyente</option>
              <option value="O-15">Autorretenedor</option>
              <option value="O-23">Agente de retención IVA</option>
              <option value="O-47">Regimen Simple de Tributación</option>
              <option value="R‐99‐PN">No Responsable</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <label class="label">Logo empresa</label>
      </div>
      <div class="column is-4">
        <div class="file has-name">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              accept=".png"
              ref="file"
              @change="onFileChange"
            />
            <span class="file-cta">
              <span class="file-icon">
                <span class="material-icons">attach_file</span>
              </span>
              <span class="file-label">Seleccione un Archivo… </span>
            </span>
            <span class="file-name">{{ filename }}</span>
          </label>
        </div>
      </div>
      <div class="column is-2">
        <button class="button is-link" @click="submitFile">
          <span class="file-icon">
            <span class="material-icons">cloud_upload</span>
          </span>
          <span>Subir Archivo</span>
        </button>
      </div>
      <div class="column is-6">
        <figure class="image is-256x256">
          <img v-show="empresa.logo64" :src="urllogo" />
        </figure>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <button class="button is-large is-link" @click="saveEmpresa">
          Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import functions from "@/helpers/functions";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      filename: "Seleccionar archivo",
      empresatoedit: {
        nombrec: "",
        nombre: "",
        direccion: "",
        telefono: "",
        correo: "",
        codciudad: "",
        codpais: "",
        codpostal: "",
        mmercantil: "",
        tipopersona: "",
        regimenfiscal: "",
        regimen: [],
      },
      ciudades: [],
      paises: [],
    };
  },
  computed: {
    ...mapState(["empresa"]),
    infoempresa() {
      return this.empresa._id;
    },
    urllogo() {
      return `data:image/png;base64, ${this.empresa.logo64}`;
    },
  },
  methods: {
    async submitFile() {
      try {
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("name", this.filename);
        const result = await apiServices.post(
          `/uploadimagetobase64`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.$store.commit("refreshEmpresa", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Existen errores. No se pudo subir los registros",
          type: "is-danger",
          duration: 4000,
        });
        this.error = err.response.data;
        console.log(this.error);
      }
    },
    onFileChange(e) {
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        this.file = this.$refs.file.files[0];
        this.filename = file.name;
      }
    },
    async saveEmpresa() {
      try {
        const _this = this;
        for (let index = 0; index < _this.ciudades.length; index++) {
          if (_this.empresatoedit.codciudad === _this.ciudades[index].codigo) {
            _this.empresatoedit.ciudad = _this.ciudades[index].nombre;
            break;
          }
        }
        for (let index = 0; index < _this.paises.length; index++) {
          if (_this.empresatoedit.codpais === _this.paises[index].codigo) {
            _this.empresatoedit.npais = _this.paises[index].nombre;
            break;
          }
        }
        const result = await apiServices.post(
          `/editempresa`,
          this.empresatoedit
        );
        if (result.data) {
          this.$store.commit("refreshEmpresa", result.data);
          this.$store.dispatch("notify", {
            message: `Empresa Editada con exito`,
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    replacedataempresa() {
      try {
        this.empresatoedit.nombrec = this.empresa.nombrec;
        this.empresatoedit.nombre = this.empresa.nombre;
        this.empresatoedit.direccion = this.empresa.direccion;
        this.empresatoedit.telefono = this.empresa.telefono;
        this.empresatoedit.correo = this.empresa.correo;
        this.empresatoedit.codciudad = this.empresa.codciudad;
        this.empresatoedit.codpais = this.empresa.codpais;
        this.empresatoedit.codpostal = this.empresa.codpostal;
        this.empresatoedit.mmercantil = this.empresa.mmercantil;
        this.empresatoedit.tipopersona = this.empresa.tipopersona;
        this.empresatoedit.regimen = this.empresa.regimen;
        this.empresatoedit.tidentif = this.empresa.tidentif;
        this.empresatoedit.cuentacartera = this.empresa.cuentacartera;
        this.empresatoedit.comprobanteingreso = this.empresa.comprobanteingreso;
        this.empresatoedit.comprobantefactura = this.empresa.comprobantefactura;
      } catch (err) {
        console.log(err);
      }
    },
    async traeParametros() {
      try {
        const _this = this;
        let result;
        result = await apiServices.get(`/parametros`);
        _this.ciudades = [];
        _this.paises = [];
        result.data.forEach(function (key, val) {
          if (key.codigo === 1) {
            const myObj = {
              nombre: key.parametro.nombre,
              codigo: key.parametro.codigo,
            };
            _this.ciudades.push(myObj);
          } else {
            const myObj1 = {
              nombre: key.parametro.nombre,
              codigo: key.parametro.codigo,
            };
            _this.paises.push(myObj1);
          }
        });
        _this.ciudades = functions.order(_this.ciudades, "codigo");
        _this.paises = functions.order(_this.paises, "codigo");
      } catch (err) {
        console.log("ocurrio un problema cargando las cuentas", err);
      }
    },
  },
  watch: {
    infoempresa(nv, ov) {
      if (nv !== "no id") {
        this.replacedataempresa();
      }
    },
  },
  created() {
    if (this.empresa._id !== "no id") {
      this.replacedataempresa();
    }
    this.traeParametros();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/empresa/Empresa.vue